import type {
  DeliveryAreaGetBuyerAreaResponseType,
  DeliveryAreaGetBuyerAreaRequestType,
} from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptions,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useDeliveryAreaGetBuyerAreas = <
  TData = DeliveryAreaGetBuyerAreaResponseType,
>(
  params: DeliveryAreaGetBuyerAreaRequestType,
  options?: ApiV2QueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [
      user?.uid,
      business?.id,
      ServerStateKeys.DeliveryAreaSellarDistribution,
      params,
    ],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `delivery-area/buyer-area`,
        params,
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultQueryOptions(options),
  });
};
